import { createContext } from "react";


export const GlobalComponentsContext =
  createContext<Nullable<GlobalComponentsContextValue>>(undefined);

